export default __webpack_public_path__ + "static/sales-growth-illustration-1c4ba8e249d8f902a71414861072861a.png";